import { render, staticRenderFns } from "./index.vue?vue&type=template&id=771a5cc6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771a5cc6')) {
      api.createRecord('771a5cc6', component.options)
    } else {
      api.reload('771a5cc6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=771a5cc6&", function () {
      api.rerender('771a5cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/components/forget/index.vue"
export default component.exports